import { TextField, useFieldHelper } from 'framework/ui/field';
import React from 'react';

const ProjectSowNameField = ({
  sowIdSource,
  projectNameSource,
  ...props
}: {
  sowIdSource?: string;
  projectNameSource?: string;
}) => {
  const { getValue: projectName } = useFieldHelper({ source: projectNameSource });
  const { getValue: sowId } = useFieldHelper({ source: sowIdSource });

  return <TextField {...props} value={sowId() ? `${projectName()}-${sowId()}` : projectName()} />;
};
export default ProjectSowNameField;
